
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
window.MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

Vue.component('sales-per-month-chart-component', require('./components/SalesPerMonthChart.vue'));
Vue.component('sales-per-month-per-restaurant-chart-component', require('./components/SalesPerMonthPerRestaurantChart.vue'));

if (document.getElementById("chart-row")) {
    const app = new Vue({
        el: '#chart-row'
    });
}

$('.image-option input').change(function () {
    if (this.checked) {
        $(this).siblings('label').children('img').attr('src')
        $(".image-preview img").attr('src', $(this).siblings('label').children('img').attr('src'));
    }
})
const responsiveMenu = require('./components/responsive-menu.js')
jQuery("#responsive-menu-icon").click(function () {
    responsiveMenu.menuClick();      
});
$('[data-toggle="tooltip"]').tooltip()


// WEBPACK FOOTER //
// ./resources/js/app.js